<template lang="html">
  <div class="container">
    <el-container class="container_cen">
      <el-header class="container-header">
        <div :class="isCollapse ? 'logo logo_left' : 'logo'">
          <!-- <img src="../assets/img/logo.png" alt=""> -->
          <img
            v-if="!isCollapse"
            src="https://cargocnwebimage.oss-cn-beijing.aliyuncs.com/hhypc/hhy_logo1.png"
          />
          <img
            v-if="isCollapse"
            src="https://cargocnwebimage.oss-cn-beijing.aliyuncs.com/hhypc/hhy_min_logo1.png"
          />
        </div>
        <!--
      <el-col :span="5" class="breadcrumb-container">
        <el-breadcrumb separator="/" class="breadcrumb-inner">
          <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">{{ item.name  }}</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      -->

        <el-col class="userinfo">
          <el-select
            v-model="value"
            size="medium"
            style="width:200px"
            class="leftchoose"
            filterable
            :filter-method="changeTabOtp"
            @change="routerTo(value)"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsrel"
              :key="item.code"
              :label="item.label"
              :value="item.value || item.path"
            >
            </el-option>
          </el-select>
          <div class="head_right">
            <span v-if="userInfo.userType != 1">{{
              userInfo.attrs.compName
            }}</span>
            <span v-if="userInfo.attrs.orgName"
              >/{{ userInfo.attrs.orgName }}</span
            >
            <!-- <div class="userName1">{{userName1}}</div> -->
            <el-dropdown trigger="click" size="mini">
              <span class="username"
                >{{ userInfo.userName }}
                <i class="el-icon-caret-bottom" style="color: #333"></i
              ></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showPasswordDialog = true"
                  >修改密码</el-dropdown-item
                >
                <el-dropdown-item
                  @click.native="doShowAccountDialog"
                  v-if="authAccountList.length > 1"
                  >切换账户</el-dropdown-item
                >
                <el-dropdown-item divided @click.native="logout"
                  >退出登录</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-header>
      <el-main class="main">
        <el-container>
          <el-aside class="menu" :width="menuWidth">
            <el-menu
              active-text-color="#DDDDDD"
              :default-active="$route.path"
              :collapse="isCollapse"
              :default-openeds="openeds"
              class="el-menu-vertical-demo"
              text-color="#DDDDDD"
              @open="handleOpen"
              @close="handleClose"
              :style="'height:' + (screenHeight - 105) + 'px'"
            >
              <template
                v-for="(item, index) in routes"
                v-if="!item.hidden"
              >
                <el-submenu :index="index + ''" v-if="!item.single">
                  <template slot="title">
                    <!--<i :class="item.iconCls"></i>-->
                    <i :class="item.iconCls"></i>
                    <span class="menu-level-1">{{ item.name }}</span>
                  </template>

                  <el-menu-item
                    v-for="(child, idx1) in item.children"
                    class=""
                    @click="addTab(child, item.path + child.path)"
                    :index="index + '-' + idx1"
                    :key="child.id"
                    v-if="!child.children || child.children.length == 0"
                  >
                    <span class="menu-level-2">{{ child.name }}</span>
                  </el-menu-item>

                  <el-submenu :index="index + '-' + idx1" v-else>
                    <template slot="title">
                      <span class="menu-level-2">{{ child.name }}</span>
                    </template>
                    <el-menu-item
                      @click="addTab(chd, item.path + child.path + chd.path)"
                      :index="index + '-' + idx1 + '-' + idx2"
                      v-for="(chd, idx2) in child.children"
                      :key="chd.id"
                    >
                      <i class="menu-border icon"></i>
                      <i class="el-icon-menu icon"></i>
                      <span>{{ chd.name }}</span>
                    </el-menu-item>
                  </el-submenu>
                </el-submenu>

                <router-link
                  v-else
                  v-for="child in item.children"
                  :index="child.path"
                  :key="child.path"
                  :to="child.path"
                >
                  <div @click="addTab(child)" class="menu-level-1">
                    {{ child.name }}
                  </div>
                </router-link>
              </template>
            </el-menu>
          </el-aside>
          <el-main class="content">
            <ul
              v-show="showContextMenu"
              :style="{ left: left + 'px', top: top + 'px' }"
              class="context-menu"
            >
              <li @click="reaseChangeTab">刷新当前</li>
              <li @click="closeAllTabs">关闭所有</li>
              <li @click="closeOtherTabs">关闭其他</li>
            </ul>
            <!-- tab样式 -->
            <el-container direction="horizontal" style="background: #fff;">
              <el-aside width="32px">
                <div
                  v-if="isCollapse"
                  :class="isCollapse ? 'icon_collapse_left' : 'icon_collapse'"
                  @click="toggleMenu"
                >
                  <i class="el-icon-arrow-right"></i>
                </div>
                <div
                  v-if="!isCollapse"
                  :class="isCollapse ? 'icon_collapse_left' : 'icon_collapse'"
                  @click="toggleMenu"
                >
                  <i class="el-icon-arrow-left"></i>
                </div>
              </el-aside>
              <el-main class="tabs">
                <el-tabs
                  v-model="active"
                  type="border-card"
                  @tab-click="changeTab"
                  @tab-remove="closeTab"
                  @contextmenu.prevent.native="contextMenu($event)"
                >
                  <el-tab-pane
                    :key="item.name"
                    v-for="(item, index) in tabs"
                    :label="item.name"
                    :name="item.name"
                    :closable="index > 0"
                  ></el-tab-pane>
                </el-tabs>
              </el-main>
            </el-container>
            <el-row
              class="page-content"
              :style="'height:' + (screenHeight - 100) + 'px'"
            >
              <el-col :span="24">
                <!-- <i :class="'collapse-icon el-icon-d-arrow-'+(isCollapse?'right':'left')" ></i> -->

                <transition name="fade" mode="out-in">
                  <keep-alive :include="cachedViews">
                    <router-view :key="$route.fullPath"></router-view>
                  </keep-alive>
                </transition>
              </el-col>
            </el-row>
          </el-main>
        </el-container>
      </el-main>
    </el-container>

    <el-dialog
      center
      title="修改密码"
      :visible.sync="showPasswordDialog"
      width="40%"
      height="400"
    >
      <!-- 内容主体区域 -->
      <el-form
        :model="updatePassForm"
        :rules="updatePassFormRules"
        ref="updatePassFormRef"
        label-width="140px"
        size="mini"
      >
        <el-form-item label="原密码" prop="originalPassword">
          <el-input
            placeholder="请输入原密码"
            type="password"
            v-model="updatePassForm.originalPassword"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPass">
          <el-input
            placeholder="请设置新密码"
            type="password"
            v-model="updatePassForm.newPass"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="newPassword">
          <el-input
            placeholder="请确认新密码"
            type="password"
            v-model="updatePassForm.newPassword"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPasswordDialog = false" size="mini"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="changePassword"
          size="mini"
          :disabled="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      center
      title="切换账户"
      :visible.sync="showAccountDialog"
      width="50%"
      height="400"
    >
      <!-- 内容主体区域 -->
      <el-table
        class="mt10"
        ref="authTable"
        :data="authAccountListUsable"
        highlight-current-row
        @current-change="handleCurrentChange"
        border
      >
        <el-table-column type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="user.compName" label="公司"> </el-table-column>
        <el-table-column prop="user.orgName" label="部门"> </el-table-column>
        <el-table-column prop="user.userName" label="授权账户">
        </el-table-column>
      </el-table>

      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAccountDialog = false" size="mini"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { post } from "../api/ajax";
import { initMenu } from "../utils/utils";
import router from "../router";
import store from "../store";
import { log } from "three";
export default {
  components: {},
  inject: ["reload"],
  data() {
    //此处即表单发送之前验证
    // console.log(112342342);
    let validateNewPassword = (rule, value, callback) => {
      if (value === this.updatePassForm.originalPassword) {
        callback(new Error("新密码不能与原密码相同!"));
      } else {
        callback();
      }
    };
    let validateNewPassword2 = (rule, value, callback) => {
      if (value !== this.updatePassForm.newPass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      openeds: ["0"],
      exclude: "/businessm/SourceNew",
      userType: this.$store.state.sharing.userInfo.userType,
      screenHeight: document.body.clientHeight,
      isCollapse: false,
      menuWidth: "230px",
      showContextMenu: false,
      contextMenuTab: "",
      userName1: "",
      left: 0,
      top: 0,
      userInfo: {},
      active: "",
      tabs: [],
      showPasswordDialog: false,
      showAccountDialog: false,
      options: [],
      optionsrel: [],
      value: "  请输入你想要搜索的内容",
      authAccountList: [],
      loading: false,
      changingAccount: false,
      // 修改密码的表单数据
      updatePassForm: {
        originalPassword: "",
        newPass: "",
        newPassword: ""
      },
      // 修改密码的表单验证
      updatePassFormRules: {
        originalPassword: [
          { required: true, message: "请输入原密码", trigger: "blur" },
          {
            min: 6,
            max: 16,
            message: "长度在 6 到 16 个字符",
            trigger: "blur"
          }
        ],
        newPass: [
          { required: true, message: "请输入密码", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 16,
          //   message: "长度在 6 到 16 个字符",
          //   trigger: "blur"
          // },
          { validator: validateNewPassword, trigger: "blur" },
          {
            pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])^.{12,16}$/,
            message: "必须包含⼤⼩写字母、数字、特殊字符长度12-16位",
            trigger: "blur"
          }
        ],
        newPassword: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          // {
          //   min: 6,
          //   max: 16,
          //   message: "长度在 6 到 16 个字符",
          //   trigger: "blur"
          // },
          { validator: validateNewPassword2, trigger: "blur" },
          {
            pattern: /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])^.{12,16}$/,
            message: "必须包含⼤⼩写字母、数字、特殊字符长度12-16位",
            trigger: "blur"
          }
        ]
      },
      websock: null,
      routes: []
    };
  },
  watch: {
    $route(to, from) {
      //this.active = to.name;
      //this.curPage = to.name;
    }
  },
  beforeRouteLeave(to, from, next) {
    let tabs = this.$store.state.sharing.tabs;
    if (to.name == "申请开票" || from.name == "申请开票" || to.name == "发货新建" || from.name == "发货新建") {
      console.log(to);
      console.log(from);
      from.meta.keepAlive = true; // xxxx代表B页面
      to.meta.keepAlive = true;
    }
    next();
  },

  activated() {
    // console.log("activated", this.routes)
    var routes = localStorage.getItem("routes");
    this.routes = routes ? JSON.parse(routes) : [];
    this.value = '';
    this.optionsrel = [];
    this.options = [];
    var newRoutes = localStorage.getItem("routes");
    if(newRoutes) {
      newRoutes = JSON.parse(newRoutes);
      newRoutes.map((item, itemIndex) => {
        let that = this;
        if (item.children) {
          item.children.map((routerType, typeIndex) => {
            if (routerType.children) {
              routerType.children.map((router, rosIndex) => {
                //因为报表管理- 月度对账单 暂时没用上  页面打开是空白 所有前端处理删掉 月度对账单在页面的展示
                if (router.name == "月度对账单") {
                  routerType.children.splice(router, 1);
                }
                // console.log(router.name);
                if (router !== undefined) {
                  that.options.push({
                    value: router.path,
                    label: router.name,
                    id: router.id,
                    path: router.path,
                    name: router.name,
                    openId: [itemIndex, typeIndex, rosIndex]
                  });
                }
              });
            } else {
              if (routerType !== undefined) {
                that.options.push({
                  value: routerType.path,
                  label: routerType.name,
                  id: routerType.id,
                  path: routerType.path,
                  name: routerType.name,
                  openId: [itemIndex, typeIndex]
                });
              }
            }
          });
        }
      });
    };
    // console.log('搜索资源1', this.options);

    var findAvaliables = JSON.parse(localStorage.getItem("findAvaliables"));
    if (!findAvaliables || findAvaliables.length < 1) {
      let userInfo = JSON.parse(localStorage.getItem("login"));
      let userId = userInfo.userId;
      let userName = userInfo.userName;
      this.userName1 = userName.substr(0, 1);
      post("/api/au/user-auth/findAvaliables", {})
        .then(res => {
          let accounts = res.items;
          let tmp = [];
          tmp.push({
            userId: userId,
            user: {
              userName: `我的账户：${userName}`,
              compName: userInfo.attrs.compName,
              orgName: userInfo.attrs.orgName
            }
          });
          if (accounts.length > 0) {
            for (let i = 0; i < accounts.length; i++) {
              tmp.push(accounts[i]);
            }
            this.authAccountList = tmp;
            localStorage.setItem("findAvaliables", JSON.stringify(tmp));
            if (tmp.length > 1) {
              this.doShowAccountDialog();
            }
          }
        })
        .catch(err => {
          this.$message.error(err.data.retDesc);
        });
    } else {
      this.authAccountList = findAvaliables;
    }


    let tabs = this.$store.state.sharing.tabs;
    if (!tabs || tabs.length < 1) {
      tabs = localStorage.getItem("tabs");
      tabs = tabs ? JSON.parse(tabs) : []
    }
    if (tabs && tabs.length > 0) {
      this.tabs = tabs;
      this.active = this.$route.name;
    } else {
      let obj = {};
      obj.path = this.$route.path;
      obj.name = this.$route.name;
      this.active = this.$route.name;
      this.tabs.push(obj);
    }



    this.userInfo = JSON.parse(localStorage.getItem("login"));
    this.tabs.map(item => {
      if (JSON.stringify(this.options).indexOf(JSON.stringify(item)) === -1) {
        this.options.push(item);
      } else {
      }
    });
    this.$root.$on("routeEvent", res => {
      console.log("routeEvent", res);
      if (JSON.stringify(this.options).indexOf(JSON.stringify(res)) === -1) {
        this.options.push(res);
      } else {
      }
      this.addTab(res, res.path);
    });
    this.$root.$on("websockEvent", res => {
      console.log(res);
      this.websocketsend(res);
    });
  },

  created() {

    window.addEventListener("resize", this.handleResize);

    //页面打开时先关闭长连接
    // this.websocketclose();
    //页面刚进入时开启长连接
    this.initWebSocket();
  },
  computed: {
    // routes() {
    //   var routes = localStorage.getItem("routes");
    //   if (!routes) return [];
    //   console.log(JSON.parse(routes));
    //   return JSON.parse(routes)
    //   // return this.$store.state.sharing.routes;
    // },
    authAccountListUsable() {
      let authAccountList = this.authAccountList || [];
      let userInfo = this.$store.state.sharing.userInfo || {};
      let userId = userInfo.userId;
      let tmp = [];
      for (let i = 0, l = authAccountList.length; i < l; i++) {
        if (authAccountList[i].userId != userId) {
          tmp.push(authAccountList[i]);
        }
      }
      return tmp;
    },
    cachedViews() {
      //计算属性通过vuex获取缓存的路由
      // console.log(this.$store.state.sharing.cachedViews);
      var cachedViews = this.$store.state.sharing.cachedViews;
      return cachedViews.join(",");
    }
  },
  mounted() {
    console.log("mounted");
    
    // console.log(this.userInfo.userName);
    
    document.addEventListener("click", e => {
      this.showContextMenu = false;
    });
    // window.addEventListener('beforeunload', e => {
    //   this.websock.close() //离开路由之后断开websocket连接
    // })
    // this.handleOpen([3])
    var userInfo = this.$store.state.sharing.userInfo;
    if (!userInfo || Object.keys(userInfo).length < 1) {
      var login = localStorage.getItem("login");
      login = login ? JSON.parse(login) : '',
      this.$store.commit("login", login); //保存登录信息到vuex中
      this.$store.commit("token", login ? login.attrs.token : '');
      this.$store.commit("tabs", []);
      initMenu(router, store, login ? login.attrs.res : '');
    }
  },
  beforeDestroy() {
    console.log("看看卸载不");
  },
  destroyed() {
    console.error("页面卸载");
    this.websock.close(); //离开路由之后断开websocket连接
  },
  methods: {
    initWebSocket() {
      // console.log(process.env,"NEWWS_URL");
      // console.log(window.location.href);
      let url = window.location.href;
      let wsUrl = "";
      // url.indexOf("hhycs")
      if (url.indexOf("hhy-test") != -1) {
        // wsUrl = "wss://test-smn.cargocn.com"; //测试
        wsUrl = "wss://test-smn.cargocn.com:8600";
      } else {
        wsUrl = "wss://smn.cargocn.com"; //正式
      }
      //初始化weosocket
      var userInfo = JSON.parse(localStorage.getItem("login"));
      const wsuri =
        wsUrl +
        "/12c65ed107762047bd558d76ce1a92ea?authorization=" +
        userInfo.attrs.token +
        "&userId=" +
        userInfo.userId +
        "&mobile=" +
        userInfo.mobile +
        "&userName=" +
        userInfo.userName +
        "&userType=" +
        userInfo.userType; //ws地址
      // console.log(wsuri);
      this.websock = new WebSocket(wsuri);
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen(res) {
      // console.log("WebSocket连接成功");
    },
    websocketonerror(e) {
      //错误
      // console.log("WebSocket连接发生错误");
    },
    websocketonmessage(e) {
      // console.log(e);
      var getData = JSON.parse(e.data);
      if (getData.type == "systemMessage") {
        this.$notify({
          title: "系统通知",
          message: getData.date,
          position: "bottom-right",
          duration: 300000
        });
        this.speckText(getData.date);
      } else if (getData.type == "personal") {
        this.$root.$emit("refreshList", "刷新页面");
        // this.$confirm(getData.data, "系统通知", {
        //   confirmButtonText: "确定",
        //   cancelButtonText: "取消",
        //   showCancelButton: false,
        //   showConfirmButton: false,
        //   type: "info"
        // })
        //   .then(() => {})
        //   .catch(err => {
        //     //点击取消
        //   });
        this.$notify({
          title: "系统通知",
          message: getData.data,
          position: "bottom-right",
          duration: 5000
        });
      }
      //数据接收
      const redata = JSON.parse(e.data); // 接收数据
      // console.log(redata.value);
    },
    speckText(str) {
      var url =
        "https://tts.baidu.com/text2audio?cuid=baike&lan=ZH&ctp=1&pdt=301&vol=9&rate=32&per=4&tex=" +
        encodeURI(str);
      var n = new Audio(url);
      n.src = url;
      n.play();
    },
    websocketsend(agentData) {
      this.$message.success({
        message: "发送成功！"
      });
      // console.log(this.websock);
      //数据发送
      this.websock.send(agentData);
    },

    websocketclose(e) {
      //关闭
      // console.log("connection closed (" + e.code + ")");
      this.initWebSocket();
    },
    handleResize(event) {
      this.screenHeight = document.body.clientHeight;
    },
    routerTo(value) {
      // console.log('搜索资源2', this.options);
      let findVal = this.options.find(item => {
        this.openeds = [];
        this.openeds.push(item.openId[0].toString());
        this.openeds.push(item.openId[0] + "-" + item.openId[1]);
        return item.path == value;
      });

      this.$router.push(this.value);
      // this.$store.commit("tabs", this.value);
      this.addTab(findVal, findVal.path); // 往tab页添加router
      this.value = ""; //清空搜索
      // console.log(this.value);
    },
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
      this.openeds.push(key);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
      this.openeds.map((item, index) => {
        if (key == item) {
          this.openeds.splice(index, 1);
        }
      });
    },
    // 往tab页添加router
    addTab(data, path) {
      // this.handleOpen()
      // console.log(data, path);
      var routes = this.$store.state.sharing.routes;
      const obj = Object.assign({}, data);
      obj.path = path;
      var tab = null;
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i].name == obj.name) {
          tab = this.tabs[i];
          break;
        }
      }
      if (tab == null) {
        tab = obj;
        this.tabs.push(obj);
        this.$store.commit("tabs", this.tabs);
        this.$router.push(tab.path);
      }
      this.active = tab.name;
      console.log(tab, this.$route.path);
      if (this.$route.path != tab.path) {
        var details = tab.details;
        if (details && details.length > 0 ) {
          for (var i = 0; i < details.length; i++) {
            if (details[i].path == this.$route.path ) {
              return;
            }
          }
        }
        // console.log(this.$router, "路由");

        if (tab.name == "驾驶舱") {
          this.$router.push(tab.path);
        } else {
          if (tab.details && tab.details.length > 0) {
            this.$router.push(tab.details[tab.details.length - 1]);
          } else {
            this.$router.push(tab.path);
          }
        }
      }

      // console.log(data);
      var isSetRoute = this.$store.state.sharing.isSetRoute; //获取展开的tabs路由信息
      var len = isSetRoute.length,
        route;
      if (len > 0) {
        var findIndex = isSetRoute.findIndex(item => {
          return item.path == path;
        });
        if (findIndex > -1) {
          route = isSetRoute[findIndex];
          this.addCachedViews(this.$store, route.name); //添加路由缓存
        }

      }
    },
    reaseChangeTab(e) {
      // console.log(e);
      this.reload();
      this.$router.replace({
        path: "/refresh",
        query: {
          t: Date.now()
        }
      });
    },
    changeTab(tab) {
      var tabs = this.$store.state.sharing.tabs;
      let routePath = tabs.find(item => {
        return item.name === tab.name;
      });
      // console.log(routePath.path);
      // this.isRefresh = false;
      // var index = parseInt(tab.index);
      // var tab = this.tabs[index];
      // if (this.$route.path == tab.path) {
      //   return;
      // }
      // var details = tab.details;
      // if (details && details.length > 0) {
      //   this.$router.push(details[details.length - 1]);
      //   return;
      // }
      this.$router.push({
        path: routePath.path,
        query: routePath.query ? routePath.query : ""
      });
    },

    closeTab(tab) {
      var index = 0;
      let path = "";
      for (let n = this.tabs.length - 1; n > 0; n--) {
        if (this.tabs[n].name == tab) {
          index = n;
          path = this.tabs[n].path;
          break;
        }
      }
      this.removeTab(index, path);
    },

    removeTab(index, path) {
      var cur = null;
      if (index == "all") {
        var ntabs = [this.tabs[0]];
        cur = ntabs[0];
        this.tabs = ntabs;
      } else {
        this.tabs.splice(index, 1);
        if (index == 0) {
          cur = this.tabs[0];
        } else {
          if (index == this.tabs.length) {
            cur = this.tabs[index - 1];
          } else {
            cur = this.tabs[index];
          }
        }
      }
      this.$router.push(cur.path);
      this.active = cur.name;
      this.$store.commit("tabs", this.tabs);
      //移除tabs时移除相应的路由缓存
      this.removeCachedViews(this.$store, path);
    },

    //更新要缓存的缓存列表
    removeCachedViews(store, path) {
      console.log(store, path);

      var cachedViews = store.state.sharing.cachedViews;

      // let name=path.split('/')[1]+'-'+path.split('/')[2]
      // console.log(name,cachedViews)
      let arr = [];
      cachedViews.forEach(item => {
        console.log(item, "item");

        if (item != path) {
          arr.push(item);
        }
      });
      console.log(arr);
      //  cachedViews.splice(index, 1);
      store.commit("cachedViews", arr);
    },

    addCachedViews(store, name) {
      // console.log("addCached", name);
      var cachedViews = store.state.sharing.cachedViews;
      if (name && typeof name === "string") {
        let i = cachedViews.indexOf(name);
        if (i > -1) {
          return;
        }
        cachedViews.push(name);
        store.commit("cachedViews", cachedViews);
      }
    },

    removeOther(tabName) {
      var tab = null;
      var tabs = this.tabs;
      for (var i = 1; i <= tabs.length - 1; i++) {
        if (tabs[i].name == tabName) {
          tab = tabs[i];
          break;
        }
      }
      tabs = [tabs[0], tab];
      this.tabs = tabs;
      this.active = tab.name;
      this.$store.commit("tabs", this.tabs);
      if (this.$route.path != tab.path) {
        this.$router.push(tab.path);
      }
    },

    toggleMenu() {
      this.isCollapse = !this.isCollapse;
      if (this.isCollapse) {
        this.menuWidth = "60px";
      } else {
        this.menuWidth = "230px";
      }
    },

    contextMenu(e) {
      let tabId = e.srcElement.id.split("-")[1] || this.active;
      this.showContextMenu = true;
      this.contextMenuTab = tabId;
      this.left = e.clientX;
      this.top = e.clientY + 10;
    },
    closeAllTabs() {
      this.showContextMenu = false;
      this.removeTab("all");
    },
    closeOtherTabs() {
      this.showContextMenu = false;
      if (this.contextMenuTab == "欢迎页" || this.contextMenuTab == "驾驶舱") {
        this.removeTab("all");
      } else {
        this.removeOther(this.contextMenuTab);
      }
    },
    changePassword() {
      var me = this;
      this.$refs.updatePassFormRef.validate(async valid => {
        if (valid) {
          const password = this.updatePassForm.originalPassword;
          const newPassword = this.updatePassForm.newPassword;
          const data = { password: password, newPassword: newPassword };
          me.loading = true;
          post("/api/au/user/changePsw", data)
            .then(res => {
              me.$message({ message: "密码修改成功", type: "success" });
              me.showPasswordDialog = false;
            })
            .catch(err => {
              me.$message.error(err.data.retDesc || "操作失败");
            })
            .finally(() => {
              me.loading = false;
            });
          me.updatePassForm = {
            originalPassword: "",
            newPass: "",
            newPassword: ""
          };
        }
      });
    },
    doShowAccountDialog() {
      let me = this;
      let userInfo = me.$store.state.sharing.userInfo || { attrs: {} };
      let authUserId = userInfo.attrs.authUserId;
      me.showAccountDialog = true;
    },
    handleCurrentChange(val) {
      let me = this;

      // 防止双击切换两次
      if (me.changingAccount) {
        return;
      }

      let userInfo = me.$store.state.sharing.userInfo || { attrs: {} };
      let curerntUserId = userInfo.userId;

      let id = val.userId;

      if (curerntUserId === id) {
        this.$message.warning("当前账户已是：" + userInfo.userName);
        return;
      }
      me.changingAccount = true;

      post("/api/au/user-auth/changeUser", {
        id: id
      })
        .then(res => {
          let user = res;
          me.$message.success({ message: "切换成功" });
          me.$store.commit("login", user); //保存登录信息到vuex中
          localStorage.setItem("login", JSON.stringify(user));
          me.$store.commit("token", user.attrs.token);
          // axios 的token从缓存里面取的，要更新缓存
          localStorage.setItem("token", user.attrs.token);
          me.$store.commit("tabs", []);
          initMenu(router, store, user.attrs.res);
          me.showAccountDialog = false;
          me.userInfo = this.$store.state.sharing.userInfo;
          me.closeAllTabs();
        })
        .catch(err => {
          me.$message.error(err.data.retDesc);
        })
        .finally(() => {
          me.changingAccount = false;
        });
    },

    //退出登录
    logout: function() {
      console.log(this.userInfo.userType + "退出");
      let me = this;
      this.$confirm("确认退出吗?", "提示", {})
        .then(() => {
          // var href = location.href;
          // if (href.indexOf('welcomeY') > -1) {
          //   // me.$router.push("/welcomeY");
          //   me.tabs = [];
          // } else {
          //   // me.$router.push("/welcome");
          //   me.tabs = [{ name: "驾驶舱", path: "/welcome" }];
          // }
          me.$store.commit("tabs", []);
          me.$store.commit("token", "");
          me.$store.commit("storageData/getDirverHead", []);
          me.$store.commit("storageData/getDirverHead2", []);
          me.$store.commit("storageData/getDirverHead3", []);
          me.$store.commit("storageData/clearAdd3", []);
          me.$store.commit("storageData/getDirverHead4", []); //退出登录初始化司机结算2.0表头
          
          // setTimeout(() => {
          //   me.$store.commit("storageData/getDirverHead4", []); //退出登录初始化司机结算2.0表头
          //   me.$store.commit("storageData/chooseList4", {listAdd: [], listDel4: []});
          // }, 1000)
          
          if (me.userInfo.userType === 1) {
            me.$router.push("/login");
          } else if (me.userInfo.userType === 2) {
            me.$router.push("/login_carr");
          } else if (me.userInfo.userType === 3) {
            me.$router.push("/login_shipper");
          }
          // let loginPath = localStorage.getItem("login-path");
          // me.$router.push("/" + (loginPath ? loginPath : "login"));
          window.sessionStorage.clear();
          window.localStorage.clear();
          //退出登录后清空路由缓存
          store.commit("cachedViews", []);
        })
        .catch(() => {});
    },
    changeTabOtp(value) {
      // 锚点查询，快捷定位
      this.optionsrel = [];
      if (value) {
        this.options.map(item => {
          if (item.label) {
            if (item.label.match(value)) {
              this.optionsrel.push(item);
              this.value = value;
            }
          }
        });
      } else {
        this.optionsrel = [];
      }
    },
    
  }
};
</script>

<style scoped lang="scss">
@import "../assets/css/them.scss";

.container {
  position: absolute;
  top: 0;
  bottom: 0;
  min-width: 1280px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .container-header {
    // background: #AEC5EF;
    background: #ffffff;
    height: 56px !important;
    padding: 0px;
    display: flex;
    justify-content: space-between;
  }
  .logo {
    height: 56px;
    // background: #086FFD;
    background: #223644;
    font-size: 22px;
    width: 230px;
    // position: relative;
    // top: 10px;
    border-color: $borderColor;
    border-right-width: 1px;
    border-right-style: solid;
    flex-shrink: 0;
    img {
      height: 50px;
      margin-left: 47px;
    }
  }
  .logo_left {
    width: 60px;
    img {
      height: 26px;
      width: 50px;
      margin-left: 0;
      margin-top: 10px;
    }
  }
  .userinfo {
    color: #333 !important;
    text-align: right;
    padding: 0px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .username {
    color: #333 !important;
    font-size: 12px;
    margin-left: 5px;
    cursor: pointer;
    .el-icon-caret-bottom {
      margin-left: 20px;
    }
  }
  .main {
    display: flex;
    overflow: hidden;
    padding: 0 !important;
    .menu {
      color: #778ca2 !important;
      width: 100%;
      background: #223644;
      color: #dddddd;
      // color: #333333;
      // background-color: rgb(84, 92, 100);
      overflow-x: hidden;
      .menu-level-1 {
        margin-left: 15px;
        font-size: 15px;
        // color: #333333;
      }
      .menu-level-2 {
        margin-left: 15px;
        font-size: 13px;
        // color: #333333;
      }
      .el-menu {
        background-color: #223644 !important;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 8px;
          height: 10px;
        }
        &::-webkit-scrollbar-track-piece {
          // background-color: #ffffff;
          // background: #394C57 ;
          background-color: #223644 !important;
          -webkit-border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb:vertical {
          height: 200px;
          background: #b2b5b9;
          //background: #AEC5EF;
          -webkit-border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb:horizontal {
          width: 5px;
          // background-color: #ffffff;
          background: #b2b5b9;
          -webkit-border-radius: 5px;
        }
      }
      .collapsed {
        width: 60px;
        // background: $globalColor;
        .item {
          position: relative;
        }
        .submenu {
          position: absolute;
          top: 0;
          left: 60px;
          z-index: 99999;
          height: auto;
          display: none;
        }
      }
    }
    .content {
      padding: 0 !important;
    }
    .collapse-icon {
      line-height: 40px;
      background: #f5f7fa;
      width: 100%;
      text-align: center;
      font-size: 18px;
      border-bottom: 1px solid #dcdfe6;
    }
    .tabs {
      padding: 0;
    }
    .page-content {
      overflow: auto;
      position: relative;
      width: 100%;
      .el-tabs__header {
        border: none !important;
      }
      &::-webkit-scrollbar {
        width: 8px;
        height: 10px;
      }
      &::-webkit-scrollbar-track-piece {
        background-color: #ffffff;
        //  background: #394C57 ;
        -webkit-border-radius: 6px;
      }

      &::-webkit-scrollbar-thumb:vertical {
        height: 200px;
        // background-color: #086FFD;
        background-color: #c2c5c7;
        -webkit-border-radius: 6px;
      }

      &::-webkit-scrollbar-thumb:horizontal {
        width: 5px;
        background-color: #ffffff;
        -webkit-border-radius: 6px;
      }
    }
  }
  .context-menu {
    margin: 0;
    padding-left: 0;
    background: #ffffff;
    z-index: 3000;
    width: 90px;
    position: absolute;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
    color: #333;
    -webkit-box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    position: absolute;
    top: 85px;
    cursor: pointer;
    line-height: 30px;
    list-style-type: none;
  }
  .context-menu :hover {
    // background: #ecf5ff;
    background: #394c57 !important;
    color: #fff;
    // color: #409eff;
  }

  .el-dropdown-menu {
    width: 100px;
    background: #394c57 !important;
  }
  .leftchoose {
    width: 220px !important;
    height: 34px;
    border-radius: 20px;
  }
  /deep/.el-submenu__title {
    color: #333;
  }
  /deep/ .el-menu {
    background: #223644 !important;
    color: #dddddd !important;
  }
  /deep/ .el-submenu__title:hover {
    background: #394c57 !important;
  }
  /deep/ .el-menu-item:hover,
  .el-menu-item:focus {
    background: #394c57 !important;
  }
  /deep/ .el-menu-item:focus {
    color: #fff !important;
    .icon {
      color: #fff;
    }
    .menu-border {
      position: absolute;
      display: inline-block;
      height: 100%;
      width: 3px;
      top: 0;
      left: 0;
      background: #fff;
    }
  }
  .el-menu-item {
    // color: #333 !important;
  }
}
.icon_collapse {
  position: absolute;
  left: 228px;
  bottom: 0px;
  // background: #086FFD;
  background: #223644;
  height: 55px;
  border-radius: 0px 10px 10px 0px;
  width: 11px;
  justify-content: center;
  align-items: center;
  display: flex;
  color: #fff;
  z-index: 1;
}
.icon_collapse_left {
  position: absolute;
  left: 59px;
  bottom: 0px;
  // background: #086FFD;
  background: #223644;
  height: 55px;
  border-radius: 0px 10px 10px 0px;
  width: 11px;
  justify-content: center;
  align-items: center;
  display: flex;
  color: #fff;
  z-index: 1;
}
.icon_collapse_right {
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(90, 138, 255, 1);
  height: 55px;
  border-radius: 0px 10px 10px 0px;
  width: 11px;
  justify-content: center;
  align-items: center;
  display: flex;
  color: #fff;
  z-index: 1;
}
.userName1 {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  text-align: center;
  line-height: 36px;
  background: #086ffd;
  color: #fff;
  margin: 0 10px;
}
.head_right {
  display: flex;
  align-items: center;
}
.container_cen {
  height: 100vh;
}
.el-container {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
</style>
<style lang="scss">
.userinfo {
  .el-input__inner {
    border-radius: 16px !important;
    // color: #D2D2D2;
    background: #f9fafc;
  }
}
// .el-menu{
//     background: #223644 !important;
//     color: #DDDDDD !important;
// }
</style>



// WEBPACK FOOTER //
// src/page/home.vue